import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GameComponent } from './pages/game/game.component';
import { InstructionsComponent } from './pages/instructions/instructions.component';
import { CollectionsComponent } from './pages/collections/collections.component';
import { GameoverComponent } from './pages/gameover/gameover.component';
import { PlayersComponent } from './pages/players/players.component';


const routes: Routes = [
  {
    path: '', component: InstructionsComponent,
  },
  {
    path: 'players', component: PlayersComponent,
  },
  {
    path: 'collections', component: CollectionsComponent,
  },
  {
    path: 'game', component: GameComponent,
  },
  {
    path: 'game-over', component: GameoverComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
